"use client";

import { useState } from "react";
import { getCountryFlag, FALLBACK_FLAG } from "@/lib/countryFlags";

interface CountryFlagProps {
  country: string;
  /** Custom element to render when the flag fails to load. Pass `null` to render nothing. If omitted, defaults to globe SVG. */
  fallback?: React.ReactNode;
}

export default function CountryFlag({
  country,
  fallback,
}: CountryFlagProps) {
  const [failed, setFailed] = useState(false);
  const hasFallbackProp = fallback !== undefined;

  if (failed) {
    if (hasFallbackProp) return <>{fallback}</>;
    return (
      <img
        src={FALLBACK_FLAG}
        alt=""
        width={20}
        height={14}
        loading="lazy"
        decoding="async"
        style={{ marginRight: 6, verticalAlign: "middle" }}
      />
    );
  }

  return (
    <img
      src={getCountryFlag(country)}
      alt=""
      width={20}
      height={14}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      style={{ marginRight: 6, verticalAlign: "middle" }}
    />
  );
}
